export const DISPATCH_LOGOUT = 'DISPATCH_LOGOUT'
export const FETCH_AUTH_INFO = 'FETCH_AUTH_INFO'
export const DISPATCH_LOGIN = 'DISPATCH_LOGIN'
export const REGISTER = 'REGISTER'
export const RESEND_TOKEN = 'RESEND_TOKEN'
export const VERIFY_TOKEN = 'VERIFY_TOKEN'
export const PASSWORD_EMAIL = 'PASSWORD_EMAIL'
export const RESET_PASSWORD = 'RESET_PASSWORD'
export const DISPATCH_ADD_PHONE = 'DISPATCH_ADD_PHONE'

//STATION INFO
export const FETCH_STATION_INFO = 'FETCH_STATION_INFO'
export const SERVER_ACTION = 'SERVER_ACTION'

//DASHBOARD
export const FETCH_STATS = 'FETCH_STATS'
export const FETCH_LISTENERS = 'FETCH_LISTENERS'
export const FETCH_LISTENER_REPORT = 'FETCH_LISTENER_REPORT'

//USER
export const FETCH_ALL_USERS = 'FETCH_ALL_USERS'
export const UPDATE_PROFILE = 'UPDATE_PROFILE'


//CHECKOUT
export const FETCH_ORDER = 'FETCH_ORDER'
export const DISPATCH_CHECKOUT = 'DISPATCH_CHECKOUT'

//MEDIA
export const FETCH_MEDIA_FILES = 'FETCH_MEDIA_FILES'

//MEDIA
export const FETCH_PLAYLISTS = 'FETCH_PLAYLISTS'

//INDEX
export const DISPATCH_DELETE = 'DISPATCH_DELETE'
export const DISPATCH_UPDATE = 'DISPATCH_UPDATE'

//SETTINGS
export const FETCH_PLANS = 'FETCH_PLANS'
export const DISPATCH_UPGRADE = 'DISPATCH_UPGRADE'
export const FETCH_INVOICES = 'FETCH_INVOICES'